import { createSlice } from "@reduxjs/toolkit";
import { setError, hideError } from './actions';
import { errorTypes, errorMessages } from 'helpers/constants';

const { ACCESS_TOKEN_INVALID, AUTHORIZE_DATA_INVALID, ACCESS_FORBIDDEN, RECORD_NOT_FOUND, TOO_MANY_REQUESTS, NOT_AUTHENTICATED } = errorMessages;
const { AUTHORIZE_DATA_INVALID: AUTHORIZE_DATA_INVALID_TYPE, NOT_AUTHENTICATED: NOT_AUTHENTICATED_TYPE} = errorTypes;

const initialState = {
  message: '',
  type: '',
  open: false
};

const slice = createSlice({
  name: 'error',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(setError, (state, action) => {
        const { type, message, status } = action.payload;
        let customErrorText = false;
        let customMessage = '';

        if (status === 401) {
          customMessage = ACCESS_TOKEN_INVALID;
          customErrorText = true;
        }
        if (status === 403) {
          customMessage = ACCESS_FORBIDDEN;
          customErrorText = true;
        }
        if (status === 404) {
          customMessage = RECORD_NOT_FOUND;
          customErrorText = true;
        }
        if (status === 429) {
          customMessage = TOO_MANY_REQUESTS;
          customErrorText = true;
        }
        if (type === AUTHORIZE_DATA_INVALID_TYPE) {
          customMessage = AUTHORIZE_DATA_INVALID;
          customErrorText = true;
        }
        if (type === NOT_AUTHENTICATED_TYPE) {
          customMessage = NOT_AUTHENTICATED;
          customErrorText = true;
        }
        state.type = type;
        state.message = customErrorText ? customMessage : message;
        state.open = true;
      })
      .addCase(hideError, state => {
        state.type = initialState.type;
        state.message = initialState.message;
        state.open = initialState.open;
      })
  }
})

export default slice.reducer